import { ReactElement } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAuthContext } from '../auth/hooks/useAuthContext'
import routes from './routes'

const CheckAuthState = ({ children }: { children: ReactElement }) => {
  const { isAuthLoading, isOnboarded, user } = useAuthContext()
  const location = useLocation().pathname.substring(1)

  if (isAuthLoading) return null

  if (user && !isOnboarded && location !== 'onboard') {
    return <Navigate replace state={{ from: location }} to={routes.onboard} />
  }

  switch (location) {
    case 'auth': {
      if (!user) {
        return children
      }

      return (
        <Navigate replace state={{ from: location }} to={routes.portal.home} />
      )
    }

    case 'onboard': {
      if (user && isOnboarded) {
        return (
          <Navigate
            replace
            state={{ from: location }}
            to={routes.portal.home}
          />
        )
      }

      if (user && !isOnboarded) {
        return children
      }

      return <Navigate replace state={{ from: location }} to={routes.auth} />
    }

    default: {
      if (user && isOnboarded) {
        return children
      }

      return <Navigate replace state={{ from: location }} to={routes.auth} />
    }
  }
}

export default CheckAuthState
